module.exports = __webpack_public_path__ + "fonts/7acf7ca6c65a1b67fa2a150162376596.txt";